module.exports = __webpack_public_path__ + "img/bg-scan-shipment.a832032c.svg";